const NotFound = () => {

    return(<>not found!</>)
}
export default NotFound;